module.exports = __webpack_public_path__ + "img/1.d050d40d.png";